import {
  IconAdjustments,
  IconAlertTriangle,
  IconArrowsExchange,
  IconBike,
  IconBriefcase,
  IconBuilding,
  IconBuildingWarehouse,
  IconCalculator,
  IconCalendar,
  IconCash,
  IconCashBanknote,
  IconCategory,
  IconChartLine,
  IconCheck,
  IconClipboardCheck,
  IconClipboardList,
  IconCreditCard,
  IconEdit,
  IconExchange,
  IconFileDescription,
  IconFileInvoice,
  IconFilePlus,
  IconFlame,
  IconGift,
  IconHelp,
  IconHelpCircle,
  IconHomeEdit,
  IconInfoCircle,
  IconList,
  IconLogin,
  IconMapPin,
  IconMessage,
  IconPalette,
  IconPercentage,
  IconPhoto,
  IconPuzzle,
  IconRefresh,
  IconReport,
  IconSearch,
  IconServer,
  IconShield,
  IconShoppingBag,
  IconShoppingCart,
  IconStatusChange,
  IconTicket,
  IconTools,
  IconUser,
  IconUserCog,
  IconUserSearch,
  IconUsersGroup,
  IconWallet,
  IconX,
} from "@tabler/icons-react";

// Per-item CarePal premium used when a cart item has no carepal_premium set
export const DEFAULT_CAREPAL_PREMIUM = 99;

// Reusable icon component with consistent styling
const MenuIcon = ({ icon: Icon }) => (
  <Icon className="group-hover:!text-primary shrink-0 size-5" />
);

export const menuItems = [
  {
    title: "Management",
    submenu: [
      {
        title: "Login As User",
        icon: <MenuIcon icon={IconLogin} />,
        link: "/login-as-user",
      },
      {
        title: "Send Customer Prompt",
        icon: <MenuIcon icon={IconMessage} />,
        link: "/send-customer-prompt",
      },
      {
        title: "Manage Communication",
        icon: <MenuIcon icon={IconMessage} />,
        link: "/manage-communication",
      },
      {
        title: "IP Whitelist",
        icon: <MenuIcon icon={IconServer} />,
        link: "/ip-whitelist",
      },
      {
        title: "Promotion Banners",
        icon: <MenuIcon icon={IconPhoto} />,
        link: "/promotion-banners",
      },
      {
        title: "Rent Update Order",
        icon: <MenuIcon icon={IconEdit} />,
        link: "/update-order",
      },
      {
        title: "Rent Update (No Price Change)",
        icon: <MenuIcon icon={IconAdjustments} />,
        link: "/update-order-without-change",
      },
      {
        title: "Wallet Credit",
        icon: <MenuIcon icon={IconCreditCard} />,
        link: "/wallet-credit",
      },
      {
        title: "Buy Estimate",
        icon: <MenuIcon icon={IconCalculator} />,
        link: "/buy-estimate",
      },
      {
        title: "Rent Estimate",
        icon: <MenuIcon icon={IconCalculator} />,
        link: "/rent-estimate",
      },
    ],
  },
  {
    title: "Verification",
    submenu: [
      {
        title: "Verify Order",
        icon: <MenuIcon icon={IconClipboardCheck} />,
        link: "/verify-order",
      },
      {
        title: "Verify Order Team",
        icon: <MenuIcon icon={IconUsersGroup} />,
        link: "/verify-order-team",
      },
      {
        title: "Seek Orders",
        icon: <MenuIcon icon={IconClipboardList} />,
        link: "/seek-orders",
      },
      {
        title: "User Lookup",
        icon: <MenuIcon icon={IconUserSearch} />,
        link: "/user-lookup",
      },
      {
        title: "Change Order Calling Number",
        icon: <MenuIcon icon={IconStatusChange} />,
        link: "/change-calling-number",
      },
    ],
  },
  {
    title: "Buy",
    submenu: [
      {
        title: "Buy Items",
        icon: <MenuIcon icon={IconShoppingCart} />,
        link: "/buy-items",
      },
      {
        title: "Buy Subcategory",
        icon: <MenuIcon icon={IconList} />,
        link: "/buy-subcategory",
      },
      {
        title: "Buy Category",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/buy-category",
      },
    ],
  },
  {
    title: "Rent",
    submenu: [
      {
        title: "Rent Items",
        icon: <MenuIcon icon={IconBuildingWarehouse} />,
        link: "/rent-items",
      },
      {
        title: "Rent Subcategory",
        icon: <MenuIcon icon={IconList} />,
        link: "/rent-subcategory",
      },
      {
        title: "Rent Category",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/rent-category",
      },
      {
        title: "Rent Super Category",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/rent-supercategory",
      },
      {
        title: "Rental Item Sub Products Update",
        icon: <MenuIcon icon={IconEdit} />,
        link: "/rental-item-sub-products-update",
      },
      {
        title: "Rental Item Ops Requests",
        icon: <MenuIcon icon={IconClipboardCheck} />,
        link: "/rental-item-ops",
      },
      {
        title: "Rental Variants",
        icon: <MenuIcon icon={IconPuzzle} />,
        link: "/rental-varients",
      },
    ],
  },
  {
    title: "Trypal",
    submenu: [
      {
        title: "Trypal Items",
        icon: <MenuIcon icon={IconBuildingWarehouse} />,
        link: "/trypal-items",
      },
      {
        title: "Trypal Brands",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/trypal-brands",
      },
      {
        title: "Trypal Inclusions",
        icon: <MenuIcon icon={IconCheck} />,
        link: "/trypal-inclusions",
      },
    ],
  },
  {
    title: "EWS",
    submenu: [
      {
        title: "EWS Categories",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/ews-categories",
      },
      {
        title: "EWS Products",
        icon: <MenuIcon icon={IconBuildingWarehouse} />,
        link: "/ews-products",
      },
      {
        title: "EWS Product Prices",
        icon: <MenuIcon icon={IconCash} />,
        link: "/ews-product-prices",
      },
      {
        title: "EWS Orders",
        icon: <MenuIcon icon={IconShoppingBag} />,
        link: "/ews-orders",
      },
      {
        title: "EWS Details",
        icon: <MenuIcon icon={IconFileDescription} />,
        link: "/ews-details",
      },
    ],
  },
  {
    title: "Surge",
    submenu: [
      {
        title: "Surge Product",
        icon: <MenuIcon icon={IconChartLine} />,
        link: "/surge-product",
      },
      {
        title: "Surge Pricing",
        icon: <MenuIcon icon={IconCalendar} />,
        link: "/surge-pricing",
      },
      {
        title: "Surge City",
        icon: <MenuIcon icon={IconMapPin} />,
        link: "/surge-city",
      },
      {
        title: "Extension Surge",
        icon: <MenuIcon icon={IconChartLine} />,
        link: "/extension-surge",
      },
    ],
  },
  {
    title: "Cancellation",
    submenu: [
      {
        title: "Request Cancellation",
        icon: <MenuIcon icon={IconX} />,
        link: "/cancel-order",
      },
      {
        title: "Cancellation Reasons",
        icon: <MenuIcon icon={IconInfoCircle} />,
        link: "/cancellation-reason",
      },
      {
        title: "Customer Cancellations",
        icon: <MenuIcon icon={IconReport} />,
        link: "/customer-cancellation-requests",
      },
      {
        title: "Cancellation Review",
        icon: <MenuIcon icon={IconRefresh} />,
        link: "/internal-cancellation-requests",
      },
      {
        title: "RTO Cancellation Review",
        icon: <MenuIcon icon={IconExchange} />,
        link: "/rto-internal-cancellation-requests",
      },
      {
        title: "Update Cancellation",
        icon: <MenuIcon icon={IconEdit} />,
        link: "/cancellation-requests-update",
      },
      {
        title: "Find Cancellation",
        icon: <MenuIcon icon={IconSearch} />,
        link: "/cancellation-requests-find",
      },
    ],
  },
  {
    title: "Refund",
    submenu: [
      {
        title: "Refund Requests",
        icon: <MenuIcon icon={IconFileInvoice} />,
        link: "/request-refunds",
      },
      {
        title: "Process Refunds",
        icon: <MenuIcon icon={IconCashBanknote} />,
        link: "/process-refunds",
      },
      {
        title: "New Process Refunds",
        icon: <MenuIcon icon={IconArrowsExchange} />,
        link: "/new-process-refunds",
      },
      {
        title: "Wallet Refund",
        icon: <MenuIcon icon={IconWallet} />,
        link: "/wallet-refund",
      },
      {
        title: "Refund Proposal",
        icon: <MenuIcon icon={IconClipboardList} />,
        link: "/refund-proposal",
      },
      {
        title: "Create Refund Proposal",
        icon: <MenuIcon icon={IconFilePlus} />,
        link: "/create-refund-proposal",
      },
      {
        title: "Refund Reasons",
        icon: <MenuIcon icon={IconHelpCircle} />,
        link: "/refund-reasons",
      },
    ],
  },

  {
    title: "Zoho Invoices",
    submenu: [
      {
        title: "Zoho Invoices",
        icon: <MenuIcon icon={IconFileInvoice} />,
        link: "/zoho-invoices",
      },
      {
        title: "Generate GST Invoice",
        icon: <MenuIcon icon={IconCashBanknote} />,
        link: "/generate-invoice",
      },
    ],
  },
  {
    title: "Tickets",
    submenu: [
      {
        title: "Customer Tickets",
        icon: <MenuIcon icon={IconTicket} />,
        link: "/customer-tickets",
      },
      {
        title: "Asset Program Lead",
        icon: <MenuIcon icon={IconTicket} />,
        link: "/assets-program-leads",
      },
      {
        title: "All Tickets",
        icon: <MenuIcon icon={IconTicket} />,
        link: "/tickets",
      },
    ],
  },
  {
    title: "Bikes",
    submenu: [
      {
        title: "Bike Inventory",
        icon: <MenuIcon icon={IconBike} />,
        link: "/bikes",
      },
      {
        title: "Bike Items",
        icon: <MenuIcon icon={IconList} />,
        link: "/bikes-items",
      },
      {
        title: "Bike Cities",
        icon: <MenuIcon icon={IconBuilding} />,
        link: "/bikes-cities",
      },
      {
        title: "Bike City Hubs",
        icon: <MenuIcon icon={IconMapPin} />,
        link: "/bikes-hubs",
      },
    ],
  },
  {
    title: "Resale",
    submenu: [
      {
        title: "Resale Category",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/resale-category",
      },
      {
        title: "Resale Subcategory",
        icon: <MenuIcon icon={IconList} />,
        link: "/resale-subcategory",
      },
      {
        title: "Resale Products",
        icon: <MenuIcon icon={IconBuildingWarehouse} />,
        link: "/resale-products",
      },
      {
        title: "Resale Quality Types",
        icon: <MenuIcon icon={IconAdjustments} />,
        link: "/resale-quality-types",
      },
      {
        title: "Resale Items",
        icon: <MenuIcon icon={IconExchange} />,
        link: "/resale-items",
      },
      {
        title: "Resale Inclusions",
        icon: <MenuIcon icon={IconCheck} />,
        link: "/resale-inclusions",
      },
      {
        title: "Resale Free Inclusions",
        icon: <MenuIcon icon={IconCheck} />,
        link: "/resale-free-inclusions",
      },
      {
        title: "Resale Addons",
        icon: <MenuIcon icon={IconPuzzle} />,
        link: "/resale-addons",
      },
    ],
  },
  {
    title: "Resale Sell",
    submenu: [
      {
        title: "Resale Sell Category",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/resale-sell-category",
      },
      {
        title: "Resale Sell Subcategory",
        icon: <MenuIcon icon={IconList} />,
        link: "/resale-sell-subcategory",
      },
      {
        title: "Resale Sell Products",
        icon: <MenuIcon icon={IconBuildingWarehouse} />,
        link: "/resale-sell-products",
      },
    ],
  },
  {
    title: "Assset Partner",
    submenu: [
      {
        title: "Assset Partner Products",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/asset-partner-products",
      },
      {
        title: "Purchased Items",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/asset-partner-purchased-items",
      },
    ],
  },
  {
    title: "Configuration",
    submenu: [
      {
        title: "Address Updates",
        icon: <MenuIcon icon={IconHomeEdit} />,
        link: "/update-address",
      },
      {
        title: "Defaulters",
        icon: <MenuIcon icon={IconAlertTriangle} />,
        link: "/defaulters",
      },
      {
        title: "Adjustments",
        icon: <MenuIcon icon={IconTools} />,
        link: "/adjustment-update",
      },
      {
        title: "Inclusions",
        icon: <MenuIcon icon={IconCheck} />,
        link: "/inclusion",
      },
      {
        title: "Return Details",
        icon: <MenuIcon icon={IconExchange} />,
        link: "/return-details",
      },
      {
        title: "BUB Advance",
        icon: <MenuIcon icon={IconCash} />,
        link: "/bub-advance-update",
      },
      {
        title: "Coupons",
        icon: <MenuIcon icon={IconPercentage} />,
        link: "/coupons",
      },
      {
        title: "FAQs",
        icon: <MenuIcon icon={IconHelp} />,
        link: "/faqs",
      },
      {
        title: "Trending Products",
        icon: <MenuIcon icon={IconFlame} />,
        link: "/trending-products",
      },
      {
        title: "Themes",
        icon: <MenuIcon icon={IconPalette} />,
        link: "/themes",
      },
      {
        title: "Occasions",
        icon: <MenuIcon icon={IconCalendar} />,
        link: "/occasions",
      },
      {
        title: "SEON Rules",
        icon: <MenuIcon icon={IconShield} />,
        link: "/seon-rules",
      },
      {
        title: "Product Media",
        icon: <MenuIcon icon={IconPhoto} />,
        link: "/product-pictures",
      },
      {
        title: "Cities",
        icon: <MenuIcon icon={IconBuilding} />,
        link: "/cities",
      },
      {
        title: "Cashback",
        icon: <MenuIcon icon={IconGift} />,
        link: "/cashback",
      },
      {
        title: "Customizable Items",
        icon: <MenuIcon icon={IconTools} />,
        link: "/customizable-items",
      },
      {
        title: "Combo Products",
        icon: <MenuIcon icon={IconList} />,
        link: "/combo-products",
      },
      {
        title: "Default Types",
        icon: <MenuIcon icon={IconCategory} />,
        link: "/default-types",
      },
      {
        title: "Product Details",
        icon: <MenuIcon icon={IconPhoto} />,
        link: "/product-details",
      },
      {
        title: "Careers",
        icon: <MenuIcon icon={IconBriefcase} />,
        link: "/carrers",
      },
      {
        title: "Our Teams",
        icon: <MenuIcon icon={IconUserCog} />,
        link: "/our-teams",
      },
      {
        title: "Update Customer Type",
        icon: <MenuIcon icon={IconUser} />,
        link: "/update-customer-type",
      },
      {
        title: "Warehouses",
        icon: <MenuIcon icon={IconUser} />,
        link: "/warehouse",
      },
    ],
  },
];
